import Script from 'next/script';
import { ASSET_BASE_URL } from '../../constants';

// NOTE: google tag manager scripts requires id checking, cannot be hosted locally
export default function ExternalScripts({ nonce }) {
	return (
		<>
			<Script id="font-awesome-css" nonce={nonce} strategy="afterInteractive">
				{`
					const link = document.createElement('link');
					link.rel = 'stylesheet';
					link.href = '${ASSET_BASE_URL}/font-awesome/css/all.min.css';
					document.head.appendChild(link);
				`}
			</Script>

			<Script
				src="https://www.googletagmanager.com/gtag/js?id=UA-167998759-1"
				nonce={nonce}
				strategy="afterInteractive"
			/>

			<Script
				id="gtag-script"
				nonce={nonce}
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              dataLayer.push(arguments);
            }

            gtag('js', new Date());
            gtag('config', 'UA-167998759-1');
            gtag('config', 'AW-939226597');`,
				}}
			/>

			<Script
				id="gtag-conversion-script"
				nonce={nonce}
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
            function gtag_report_conversion(url) {
              var callback = function () {
                if (typeof url != 'undefined') {
                  // window.location = url;
                }
              };
              gtag('event', 'conversion', {
                send_to: 'AW-939226597/Lh90CI67x9sCEOXr7b8D',
                event_callback: callback,
              });
              return false;
            }`,
				}}
			/>

			<Script
				id="gtag-manager-script"
				nonce={nonce}
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5BFWPXR')`,
				}}
			/>

			<Script
				id="tawk-script"
				nonce={nonce}
				strategy="lazyOnload"
				dangerouslySetInnerHTML={{
					__html: `
            var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
            (function(){
            var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
            s1.async=true;
            s1.src='https://embed.tawk.to/5f1a77d9a45e787d128c07c5/default';
            s1.charset='UTF-8';
            s1.setAttribute('crossorigin','*');
            s0.parentNode.insertBefore(s1,s0);
            })();`,
				}}
			/>

			<noscript
				dangerouslySetInnerHTML={{
					__html: `
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5BFWPXR" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
				}}
			/>

			<noscript
				dangerouslySetInnerHTML={{
					__html: `
            <img height="1" width="1" src="https://www.facebook.com/tr?id=330769881591094&ev=PageView&noscript=1"/>`,
				}}
			/>
		</>
	);
}
